import { useCobFxRates } from './use-cob-fx-rates';
import { setCobRates } from '@/services/currency/cob-fx-service';
import { useRatesInjector } from './use-rates-injector';

/**
 * LR-493: inject the COB (T-1) rates into the React-independent `cob-fx-service` module state so
 * `cobConvertToTarget` can be called from render, and bump the shared fx-rates version so its two
 * consumers re-render once COB lands: the Run-MTM "Delta ≈" preview (MtmPage) and the repo "Pay ≈"
 * transfer line (PostRepoMarginCallDialog). Mounts once in Layout, mirroring `useFxRatesSync`; the
 * shared injection body lives in useRatesInjector (review CU6).
 */
export const useCobFxRatesSync = () => {
  const { isLoading, isError, hasRates } = useRatesInjector(useCobFxRates(), setCobRates);
  return { isLoading, isError, isUsingCob: hasRates };
};
